import angular, { IPromise } from 'angular'

import { STATES } from '../../../lib/routes'
import { $q, $state } from '../ng-compat/imports'

/**
 * Provides training mode related modals.
 *
 * @module trainingModeModals
 */
angular
  .module('webregister.modals')
  .factory('trainingModeModals', function (Confirm: $TSFixMe) {
    /**
     * Provides training mode related modals.
     *
     * @class trainingModeModals
     * @static
     */
    return {
      /**
       * Confirmation Modal for when enabling training mode.
       *
       * @method confirmTrainingMode
       * @return {ModalInstance} The instance of the Confirm Modal
       */
      confirmTrainingMode() {
        const transitionToSaleRoute = !$state.includes(STATES.SALE)
          ? (($state.go(STATES.SALE) as unknown) as IPromise<void>)
          : $q.resolve()

        return transitionToSaleRoute.then(() =>
          Confirm({
            header: 'You’re now in training mode',
            content: `<p class="vd-p" vd-no-widow>Sales and payments you make in training mode will not be recorded. Feel
            free to try out all the features.</p>`,
            cancel: { isVisible: false },
            confirm: 'Got it',
          })
        )
      },

      /**
       * Confirmation Modal for when exiting training mode.
       *
       * @method exitTrainingModeConfirmation
       * @return {ModalInstance} The instance of the modal for the opened confirmation Modal
       */
      exitTrainingModeConfirmation() {
        return Confirm({
          header: 'Exit Training Mode?',
          content: `<p class="vd-p">Once you've left training mode, any sales and payments you make from now on will
          be recorded.</p>
          <p class="vd-p" vd-no-widow>To do more training later, click 'Enable training mode' in the Register
          settings menu.</p>`,
          cancel: 'Continue training',
          confirm: 'Exit training',
        })
      },
    }
  })
